import React from "react";
import { useTranslation } from "react-i18next";
import { MapPin, ArrowUpRight } from "lucide-react";
import { LLink } from "@/i18n/LLink";
import { useLang } from "@/i18n/LangContext";
import { pageContent, pickLang } from "@/i18n/pageContent";

const HIGHLIGHTS = [
  { key: "woudagemaal", to: "/woudagemaal", image: "/media/woudagemaal.jpg", accent: "#F3C300" },
  { key: "dok", to: "/zien-en-doen", image: "/media/lemmer-dok.jpg", accent: "#2E9CD6" },
  { key: "watersport", to: "/watersport-haven", image: "/media/lemmer-ijsselmeer.jpg", accent: "#6BC0E8" },
];

export const HighlightsSection = () => {
  const { t } = useTranslation();
  const { lang } = useLang();
  const c = pickLang(pageContent.home, lang).highlights;
  return (
    <section
      data-testid="home-highlights"
      className="bg-white py-16 sm:py-20"
    >
      <div className="ll-container">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-10 sm:mb-14">
          <div className="max-w-2xl">
            <span className="inline-block text-[#2E9CD6] font-[Poppins] font-semibold text-xs uppercase tracking-[0.2em] mb-3">
              {c.eyebrow}
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold">
              {c.title}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
          {HIGHLIGHTS.map((h) => {
            const item = c.items[h.key] || {};
            return (
              <LLink
                key={h.key}
                to={h.to}
                data-testid={`highlight-${h.key}`}
                className="group flex flex-col rounded-2xl overflow-hidden bg-white border border-[#E4EEF5] hover:border-[#6BC0E8] hover:shadow-xl transition-all duration-300"
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={h.image}
                    alt={item.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <span
                    className="absolute top-4 left-4 inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-[Poppins] font-semibold shadow-md"
                    style={{
                      backgroundColor: h.accent,
                      color: h.accent === "#F3C300" ? "#173A5E" : "#FFFFFF",
                    }}
                  >
                    <MapPin className="w-3 h-3" />
                    {item.tag}
                  </span>
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <h3 className="text-xl sm:text-2xl font-[Poppins] font-bold mb-2 text-[#173A5E]">
                    {item.title}
                  </h3>
                  <p className="text-[#3E5871] font-[Inter] text-sm sm:text-base leading-relaxed mb-4 flex-1">
                    {item.intro}
                  </p>
                  <span className="inline-flex items-center gap-1 text-[#2E9CD6] font-[Poppins] font-semibold text-sm group-hover:gap-2 transition-all">
                    {t("common.lees_meer")}
                    <ArrowUpRight className="w-4 h-4" />
                  </span>
                </div>
              </LLink>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HighlightsSection;
